import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';

@Component({
  selector: 'file-pdf-show-view',
  templateUrl: './file-pdf-show-view.component.html',
  styleUrls: ['./file-pdf-show-view.component.scss'],
})
export class FilePdfShowViewComponent implements OnInit {
  @Input() url: string = null;
  
  page: number = 1;
  totalPages: number = 0;
  zoom: number = 1.0;

  constructor(
  ) {
  }
  ngOnInit(){
  }
  
    onPdfLoad(pdf: PDFDocumentProxy) {
      this.totalPages = pdf?.numPages;
    }
  
    nextPage() {
      if (this.page < this.totalPages) this.page++;
    }
  
    prevPage() {
      if (this.page > 1) this.page--;
    }
  
    zoomIn() {
      this.zoom += 0.25;
    }
  
    zoomOut() {
      if (this.zoom > 0.5) this.zoom -= 0.25;
    }
  



}